export default __webpack_public_path__ + "static/kontaktid_tallinn-49d3954b8b48f3805ea9e039efc18740.svg";